<template>
	<div>

		<div v-if="loading">
			Loading ...
		</div>
		<div v-else-if="!Object.keys(data).length">
			<button v-on:click="load">Load</button>
		</div>
		<div v-else>

			<div v-if="!data.requests.length">
				No exchange requests on this order
			</div>
			<table v-else>
				<thead>
					<tr>
						<th>#</th>
						<th>Product</th>
						<th>Processed on</th>
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="request in data.requests">
						<td>
							{{ request.id }}
						</td>
						<td>
							{{ request.variant.sku }}
						</td>
						<td>
							<OrderLink v-if="request.assigned_order" :id="request.assigned_order.id" />
							<template v-else-if="request.inventory_checked_at">
								Last checked
								<Format style="display: inline-block;" type="date" :time="true" :value="request.inventory_checked_at.date_time" />
							</template>
							<template v-else>Pending</template>
						</td>
						<td>
							{{ request.status }}
						</td>
						<td>
							<button
								v-if="request.status == 'pending'"
								class="small"
								:disabled="saving"
								v-on:click="deleteRequest(request)">
								Delete
							</button>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="margin-top">
				<div v-if="saving">Working ...</div>
				<ProductSearch
					v-else
					v-on:select-product="productSelected"
					v-on:select-variant="variantSelected" />
			</div>

		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id',
    'autoload'
  ],
  data: () => ({
    loading: false,
    saving: false,
    data: {}
  }),
  methods: {
    productSelected (data) {
      alert('Only variants can be selected for exchange requests')
    },
    deleteRequest (request) {
      if (confirm('Are you sure?')) {
        Vue.$api.delete(
          '/order/' + this.id + '/exchange-request/' + request.id,
          {},
          {
            loader: toggle => this.saving = toggle,
            callback: data => this.load()
          }
        )
      }
    },
    variantSelected (data) {
      Vue.$api.post(
        '/order/' + this.id + '/exchange-request/' + data.id,
        {},
        {
          loader: toggle => this.saving = toggle,
          callback: data => this.load()
        }
      )
    },
    load () {
      Vue.$api.get('/order/' + this.id + '/exchange-requests', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.data = data
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
